export const schema = {
    "models": {
        "VehicleModelGeneralInfo": {
            "name": "VehicleModelGeneralInfo",
            "fields": {
                "id": {
                    "name": "id",
                    "isArray": false,
                    "type": "ID",
                    "isRequired": true,
                    "attributes": []
                },
                "Manufacturer": {
                    "name": "Manufacturer",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "ModelName": {
                    "name": "ModelName",
                    "isArray": false,
                    "type": "String",
                    "isRequired": true,
                    "attributes": []
                },
                "ModelYear": {
                    "name": "ModelYear",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": true,
                    "attributes": []
                },
                "VehicleType": {
                    "name": "VehicleType",
                    "isArray": false,
                    "type": {
                        "enum": "VehicleTypeEnum"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "BodyStyle": {
                    "name": "BodyStyle",
                    "isArray": false,
                    "type": {
                        "enum": "VehicleBodyStyleEnum"
                    },
                    "isRequired": true,
                    "attributes": []
                },
                "EngineType": {
                    "name": "EngineType",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "EnginePower": {
                    "name": "EnginePower",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "FuelType": {
                    "name": "FuelType",
                    "isArray": false,
                    "type": {
                        "enum": "FuelTypeEnum"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "Transmission": {
                    "name": "Transmission",
                    "isArray": false,
                    "type": {
                        "enum": "TransmissionTypeEnum"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "Drivetrain": {
                    "name": "Drivetrain",
                    "isArray": false,
                    "type": {
                        "enum": "DrivetrainEnum"
                    },
                    "isRequired": false,
                    "attributes": []
                },
                "Acceleration": {
                    "name": "Acceleration",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "TopSpeed": {
                    "name": "TopSpeed",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "FuelEconomy": {
                    "name": "FuelEconomy",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "InteriorFeatures": {
                    "name": "InteriorFeatures",
                    "isArray": true,
                    "type": "String",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "ExteriorFeatures": {
                    "name": "ExteriorFeatures",
                    "isArray": true,
                    "type": "String",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "SafetyFeatures": {
                    "name": "SafetyFeatures",
                    "isArray": true,
                    "type": "String",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "DriverAssistFeatures": {
                    "name": "DriverAssistFeatures",
                    "isArray": true,
                    "type": "String",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "CargoSpace": {
                    "name": "CargoSpace",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "SeatingCapacity": {
                    "name": "SeatingCapacity",
                    "isArray": false,
                    "type": "Int",
                    "isRequired": true,
                    "attributes": []
                },
                "TireSize": {
                    "name": "TireSize",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "Dimensions": {
                    "name": "Dimensions",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "Wheelbase": {
                    "name": "Wheelbase",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "Weight": {
                    "name": "Weight",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "SuspensionType": {
                    "name": "SuspensionType",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "BrakingSystem": {
                    "name": "BrakingSystem",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "ColorOptions": {
                    "name": "ColorOptions",
                    "isArray": true,
                    "type": "String",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "Price": {
                    "name": "Price",
                    "isArray": false,
                    "type": "Float",
                    "isRequired": false,
                    "attributes": []
                },
                "Warranty": {
                    "name": "Warranty",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "EntertainmentSystem": {
                    "name": "EntertainmentSystem",
                    "isArray": true,
                    "type": "String",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "ConnectivityFeatures": {
                    "name": "ConnectivityFeatures",
                    "isArray": true,
                    "type": "String",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "Aerodynamics": {
                    "name": "Aerodynamics",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "PerformancePackages": {
                    "name": "PerformancePackages",
                    "isArray": true,
                    "type": "String",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "Certifications": {
                    "name": "Certifications",
                    "isArray": true,
                    "type": "String",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "CountryOfOrigin": {
                    "name": "CountryOfOrigin",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "CompetingModels": {
                    "name": "CompetingModels",
                    "isArray": true,
                    "type": "String",
                    "isRequired": false,
                    "attributes": [],
                    "isArrayNullable": true
                },
                "Information": {
                    "name": "Information",
                    "isArray": false,
                    "type": "String",
                    "isRequired": false,
                    "attributes": []
                },
                "Picture": {
                    "name": "Picture",
                    "isArray": false,
                    "type": "AWSURL",
                    "isRequired": false,
                    "attributes": []
                },
                "createdAt": {
                    "name": "createdAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                },
                "updatedAt": {
                    "name": "updatedAt",
                    "isArray": false,
                    "type": "AWSDateTime",
                    "isRequired": false,
                    "attributes": [],
                    "isReadOnly": true
                }
            },
            "syncable": true,
            "pluralName": "VehicleModelGeneralInfos",
            "attributes": [
                {
                    "type": "model",
                    "properties": {}
                },
                {
                    "type": "auth",
                    "properties": {
                        "rules": [
                            {
                                "allow": "public",
                                "operations": [
                                    "create",
                                    "update",
                                    "delete",
                                    "read"
                                ]
                            }
                        ]
                    }
                }
            ]
        }
    },
    "enums": {
        "DrivetrainEnum": {
            "name": "DrivetrainEnum",
            "values": [
                "AWD",
                "FWD",
                "RWD",
                "BWD",
                "OTHER"
            ]
        },
        "EngineCategoryEnum": {
            "name": "EngineCategoryEnum",
            "values": [
                "GAS",
                "DIESEL",
                "ELECTRIC",
                "HYBRID",
                "STEAM",
                "JET",
                "PROP",
                "OTHER"
            ]
        },
        "VehicleBodyStyleEnum": {
            "name": "VehicleBodyStyleEnum",
            "values": [
                "COMPACT",
                "SEDAN",
                "HATCHBACK",
                "PICKUP_TRUCK",
                "SUV",
                "SPORTS",
                "CRUISER",
                "SPORTBIKE",
                "SEMI",
                "FREIGHT",
                "PASSENGER",
                "CARGO",
                "JET",
                "COMMERCIAL",
                "CARGO_SHIP",
                "YACHT",
                "OTHER"
            ]
        },
        "VehicleTypeEnum": {
            "name": "VehicleTypeEnum",
            "values": [
                "CAR",
                "MOTORCYCLE",
                "TRUCK",
                "PLANE",
                "TRAIN",
                "SHIP"
            ]
        },
        "TransmissionTypeEnum": {
            "name": "TransmissionTypeEnum",
            "values": [
                "MANUAL",
                "AUTOMATIC",
                "CVT",
                "SEMI_AUTOMATIC",
                "OTHER"
            ]
        },
        "FuelTypeEnum": {
            "name": "FuelTypeEnum",
            "values": [
                "GASOLINE",
                "DIESEL",
                "ELECTRIC",
                "HYBRID",
                "COAL",
                "JETFUEL",
                "OTHER"
            ]
        }
    },
    "nonModels": {},
    "codegenVersion": "3.4.4",
    "version": "601b68039781371c87cb8494429de1cb"
};